module.exports = __webpack_public_path__ + "img/icon3.6b129b19.svg";